import * as React from 'react';

import {
	CheckinOrderFragment,
	CheckoutOrderFragment,
	OrderAdditionalServiceGdsServiceServiceType,
	OrderAdditionalServicesFragment
} from '@websky/graphql';
import { CardExtrasContextSelectors, CardExtrasProviderProps } from '../CardExtras.context';
import { ServicePayload } from '../../Checkout/store/selectedServices/actions';
import { CardExtraGdsService, CardExtraFilter, CardExtraService, CardExtraVariant, ServiceType } from '../types';

export type CardExtraContextProps = CardExtrasProviderProps &
	CardExtrasContextSelectors & {
		type: ServiceType;
		filter?: CardExtraFilter;
		variant?: CardExtraVariant;
		segmentId?: string;
		additionalServicesByType: OrderAdditionalServicesFragment;
		unconfirmedServices: ServicePayload[];
		gdsServiceType: OrderAdditionalServiceGdsServiceServiceType;
		showService: boolean;
		isSingleService: boolean;
		isCanModifyServices: boolean;
		isLoading: boolean;
		onToggleService: () => void;
		onSaveServicesRequest: (serviceIds: string[]) => Promise<CheckoutOrderFragment | CheckinOrderFragment>;
		onSaveServices: (gdsServices: CardExtraGdsService[]) => Promise<void>;
		onAddServices: (gdsServices: CardExtraGdsService[]) => Promise<void>;
		onRemoveServices: (gdsServices: CardExtraService[]) => Promise<void>;
		onRemoveUnconfirmedServices: () => void;
		onViewLoyaltyStatus: () => void;
	};

const CardExtraContext = React.createContext<CardExtraContextProps>(null!);
const CardExtraProvider = CardExtraContext.Provider;

const useCardExtraCtx = () => React.useContext<CardExtraContextProps>(CardExtraContext);

export { CardExtraContext, CardExtraProvider, useCardExtraCtx };
